module.exports = __webpack_public_path__ + "img/nevoi.711f7295.svg";